import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BillingService } from '../../services/billing.service';
import { AuthService } from '../../services/auth.service';
import { environment } from '../../../environments/environment';
import {HeaderService} from "../../services/header.service";
import {SubscriptionService} from "../../services/subscription.service";

@Component({
  selector: 'app-billing',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './billing.component.html',
  styleUrl: './billing.component.scss'
})
export class BillingComponent implements OnInit {

  user: any;
  subscription: any;

  // Stripe payment links for different credit packages
  private readonly STRIPE_750_CREDITS_LINK = 'https://buy.stripe.com/fZufZiahpbmvafE1Npc7u01'; // environment.stripe?.credits750Url || 'https://buy.stripe.com/fZufZiahpbmvafE1Npc7u01';
  private readonly STRIPE_1500_CREDITS_LINK = 'https://buy.stripe.com/9B63cw3T10HR0F44ZBc7u02'; // environment.stripe?.credits1500Url || 'https://buy.stripe.com/9B63cw3T10HR0F44ZBc7u02';

  constructor(
    private billingService: BillingService,
    private authService: AuthService,
    private headerService: HeaderService,
    private subscriptionService: SubscriptionService,
  ) {}

  ngOnInit(): void {
    this.authService.authUser().subscribe(user => {
      this.user = user;
    });

    this.subscriptionService.subscriptionData().subscribe(subscription => {
      this.subscription = subscription;
    });

    this.headerService.setHeaderState('Billing', null, true);
  }

  /**
   * Opens the Stripe billing portal to manage billing account
   */
  manageBillingAccount(): void {
    this.billingService.openBillingPortal();
  }

  /**
   * Opens Stripe payment link for 750 credits in a new tab
   */
  buy750Credits(): void {
    window.open(this.STRIPE_750_CREDITS_LINK, '_blank');
  }

  /**
   * Opens Stripe payment link for 1500 credits in a new tab
   */
  buy1500Credits(): void {
    window.open(this.STRIPE_1500_CREDITS_LINK, '_blank');
  }

}
